var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M2.117 0H.529A.53.53 0 0 0 0 .53v3.174c0 .291.238.53.53.53h4.233a.53.53 0 0 0 .529-.53V1.058a.53.53 0 0 0-.53-.529H2.647z"}})}
var staticRenderFns = []

export { render, staticRenderFns }